<template>
    <router-view/>
</template>

<script>
export default {
    name: 'layout',
    components: {},
    computed: {}
}
</script>

<style lang="stylus"></style>
